


import React, { useEffect, useMemo, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	IdentityDocumentsWrapper,
	NavigationWrapper,
	PickerHOC,
	UiWrapper,
	UserWrapper,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';

import { MainModal } from 'components/MainModal/MainModal';

import { useGetError } from 'hooks/useGetError';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';

export const IdentityBiometricUpsert = PickerHOC({
	dniDocuments: {
		sourcePath: 'identityDocuments',
		sourceWrapper: IdentityDocumentsWrapper,
	},
	user: {
		sourcePath: 'user',
		sourceWrapper: UserWrapper,
	},
})(() => {
	const {
		createIdentityDocument,
		changeIdentityDocumentValidationMode,
		setMainIdentityDocument,
		loadUserIdentityDocuments,
	} = IdentityDocumentsWrapper.use();

	const { updateUser } = UserWrapper.use();
	const { dniDocuments, user } = PickerHOC.use();
	const mainUserDni = dniDocuments.find((d) => d.main);
	const mainUserDniId = mainUserDni?.id;
	const { useHeader, useFooter, useLoading, openModal } = UiWrapper.use();
	const { navigateTo } = NavigationWrapper.use();
	const { t, i18n } = useTranslation();

	const [loading, setLoading] = useState();

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('IdentityBiometricUpsert');
	const getError = useGetError();

	const docToScan = useMemo(() => user?.metadata?.documentTypeIDS || 'dni', [user]);

	// NAVIGATION
	const next = async () => {
		try {
			setLoading('Empezando el proceso...');
			CONFIG.routing.identityBiometricUpsert.nextAddNew(navigateTo);
		} catch (e) {
			setLoading(undefined);
			openModal(() => <MainModal type="error" text={getError(e)} />, {
				disableClickAway: true,
				closeButton: true,
				modalClass: isMobile ? 'modal-xl' : 'modal-main',
				key: 'modal-IdentityBiometricUpsert-KO',
			});
		}
	};

	// EFFECTS
	useEffect(() => {
		console.log('💢 dniDocuments', dniDocuments);
		console.log('💢 mainUserDni', mainUserDni);
		console.log('💢 docToScan', docToScan);
		console.log('💢 user', user);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dniDocuments, mainUserDni, user]);

	const [triggerCheck, settriggerCheck] = useState(0);

	useEffect(() => {
		const newDoc = async () => {
			setLoading('Empezando el proceso...');
			const dniHanlded = await createIdentityDocument(docToScan, true);
			await new Promise((r) => setTimeout(r, 2000));
			console.log('💢 newDniHanlded', dniHanlded);
			await changeIdentityDocumentValidationMode(dniHanlded.id, true);
			await new Promise((r) => setTimeout(r, 1000));
			await setMainIdentityDocument(dniHanlded.id);
			await new Promise((r) => setTimeout(r, 1000));
			await loadUserIdentityDocuments(user.id);
			const userPayload = {
				...user,
				metadata: {
					...user?.metadata,
					identityBiometricError: null,
				},
			};
			await updateUser(userPayload);
		};

		const upsertDoc = async () => {
			if (!mainUserDni) {
				await newDoc();
				settriggerCheck((val) => val + 1);
			} else if (
				user?.metadata?.identityBiometricError !== undefined &&
				user?.metadata?.identityBiometricError !== null
			) {
				await newDoc();
				settriggerCheck((val) => val + 1);
			} else if (mainUserDni && mainUserDni?.verificationStatus === 'VALID') {
				setLoading('El usuario ya tiene ha añadido su documento...');
				CONFIG.routing.identityBiometricUpsert.nextAlreadyAdded(navigateTo);
			} else {
				await next();
			}
		};

		upsertDoc();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [triggerCheck]);

	return <Wrapper showTopSection step={3} title="Documento de identidad"></Wrapper>;
});
